export enum KeyBoardCode {
    ENTER = 13
}
